import { InjectionToken } from '@angular/core';

export const APPNAME = new InjectionToken<string>('APPNAME');
